import { createI18n } from 'vue-i18n';
import en from '@poker/shared/i18n/en.json';
import ptBR from '@poker/shared/i18n/pt-BR.json';

export const LOCALES = ['pt-BR', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

export type MessageSchema = typeof ptBR;

export function isLocale(value: unknown): value is Locale {
  return value === 'pt-BR' || value === 'en';
}

export function detectBrowserLocale(): Locale {
  if (typeof navigator === 'undefined') return 'pt-BR';
  const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const language of languages) {
    if (language.toLowerCase().startsWith('pt')) return 'pt-BR';
    if (language.toLowerCase().startsWith('en')) return 'en';
  }
  return 'pt-BR';
}

function slavicLikePlural(choice: number, choicesLength: number): number {
  if (choicesLength === 3) return choice === 0 ? 0 : choice === 1 ? 1 : 2;
  return choice === 1 ? 0 : 1;
}

export function createAppI18n(locale: Locale = 'pt-BR') {
  return createI18n<[MessageSchema], Locale, false>({
    legacy: false,
    locale,
    fallbackLocale: 'pt-BR',
    messages: { 'pt-BR': ptBR, en: en as MessageSchema },
    pluralRules: { 'pt-BR': slavicLikePlural, en: slavicLikePlural },
    missingWarn: false,
    fallbackWarn: false,
  });
}

export type AppI18n = ReturnType<typeof createAppI18n>;
